<template>
  <v-btn
    @click="saveOffer()"
    class="link non-text-transformation mr-1 flex-shrink-1"
    :disabled="disabled"
    large
    tile
    outlined
    data-cy="button-save-offer"
  >
    {{ $t('STICKYBOX_BUTTON_SAVE') }}
  </v-btn>
</template>

<script>
export default {
  name: 'SaveOfferButton',
  props: ['disabled'],
  methods: {
    saveOffer() {
      this.$emit('onSaveClicked')
    },
  },
}
</script>
